import React, { useState, useEffect } from 'react';
import { Button, makeStyles, TableRow, TextField, Theme } from '@material-ui/core';

import BodyCell from 'components/BodyCell';
import LoadingButtonIndicator from 'components/LoadingButtonIndicator';

interface Props {
  jobActionTagTemplate?: JobActionTagTemplateModel;

  setName: React.Dispatch<React.SetStateAction<string>>;
  nameError: string;
  setNameError: React.Dispatch<React.SetStateAction<string>>;

  setDescription: React.Dispatch<React.SetStateAction<string>>;

  isSubmitting: boolean;
  onSubmit: React.FormEventHandler;
  onCancel: React.MouseEventHandler;

  primaryButtonLabel: string;
  customBackground?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  jobNoteTemplateForm: {
    height: 64
  },
  textFieldFont: {
    fontSize: '13px',
    height: 18
  },
  buttonContainer: {
    display: 'flex'
  },
  cancelButton: {
    marginRight: theme.spacing(2),
    width: 100
  },
  addButton: {
    width: 100
  }
}));

const CreateEditJobActionTagTemplateForm: React.FC<Props> = props => {
  const classes = useStyles(props);

  const { jobActionTagTemplate, setName, nameError, setNameError, setDescription } = props;

  const [actionName, setActionName] = useState<string>('');
  const [descriptionActionTag, setDescriptionActionTag] = useState<string>('');

  const { onSubmit, onCancel } = props;
  const { isSubmitting } = props;

  const { primaryButtonLabel } = props;

  useEffect(() => {
    if (!jobActionTagTemplate) {
      return;
    }

    const { name, description } = jobActionTagTemplate;
    setActionName(name);
    setDescriptionActionTag(description);
  }, [jobActionTagTemplate]);

  const handleActionNameChange = (value: string) => {
    setActionName(value);
    setName(value);
  };

  const handleDescriptionChange = (value: string) => {
    setDescriptionActionTag(value);
    setDescription(value);
  };

  const handleBlurActionTag = (value: string) => {
    let ret = true;

    if (!actionName || !actionName.trim()) {
      setNameError('Please enter action tag name');
      ret = false;
    } else {
      setNameError('');
      ret = true;
    }

    return ret;
  };

  return (
    <TableRow className={classes.jobNoteTemplateForm}>
      <BodyCell cellWidth='40%' isComponent={true}>
        <TextField
          margin='dense'
          required
          fullWidth
          id='name'
          label='Action Tag Name'
          error={nameError !== ''}
          helperText={nameError}
          value={actionName}
          onChange={event => handleActionNameChange(event.target.value)}
          onBlur={event => handleBlurActionTag(event.target.value)}
          variant='outlined'
          autoComplete='off'
          InputProps={{
            classes: {
              input: classes.textFieldFont
            }
          }}
          InputLabelProps={{
            className: classes.textFieldFont
          }}
        />
      </BodyCell>
      <BodyCell cellWidth='50%' isComponent={true}>
        <TextField
          margin='dense'
          fullWidth
          id='description'
          label='Description'
          value={descriptionActionTag}
          onChange={event => handleDescriptionChange(event.target.value)}
          variant='outlined'
          autoComplete='off'
          InputProps={{
            classes: {
              input: classes.textFieldFont
            }
          }}
          InputLabelProps={{
            className: classes.textFieldFont
          }}
        />
      </BodyCell>
      <BodyCell cellWidth='20%' isComponent={true}>
        <div className={classes.buttonContainer}>
          <Button variant='contained' disableElevation className={classes.cancelButton} onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={onSubmit} variant='contained' disableElevation color='primary' className={classes.addButton} disabled={isSubmitting}>
            {primaryButtonLabel}
            <LoadingButtonIndicator isLoading={isSubmitting} />
          </Button>
        </div>
      </BodyCell>
    </TableRow>
  );
};

export default CreateEditJobActionTagTemplateForm;
